export default __webpack_public_path__ + "static/media/Morgan.f869907e.jpeg";